/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import ImageUploader from 'react-images-upload';

const ImagePickerWeb = ({setSelectedImage}) => {
  const onDrop = (picture) => {
    setSelectedImage(picture);
  };

  return (
    <ImageUploader
      withIcon={false}
      buttonText="Add Image of Official Receipt"
      label={''}
      onChange={onDrop}
      imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
      maxFileSize={10485760}
      singleImage={true}
      buttonStyles={{
        backgroundColor: 'white',
        color: '#3A86FF',
        borderColor: '#3A86FF',
        borderWidth: 1,
        borderRadius: 8,
        borderStyle: 'solid',
        width: '80%',
        height: 36,
        fontSize: 16,
        fontWeight: '700',
      }}
      withPreview={true}
      fileContainerStyle={{boxShadow: 'none'}}
    />
  );
};

export default ImagePickerWeb;
